var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFinances = function SvgFinances(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.77 10.54h3.484c.412 0 .746.325.746.727v2.53a.746.746 0 0 1-.746.729h-3.405c-.994.013-1.863-.65-2.089-1.595a1.98 1.98 0 0 1 .433-1.652 2.1 2.1 0 0 1 1.576-.74m.15 2.66h.33a.755.755 0 0 0 .764-.746.755.755 0 0 0-.765-.745h-.329a.77.77 0 0 0-.54.213.73.73 0 0 0-.224.524c0 .413.34.749.764.754",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.769 9.048H22c0-3.397-2.036-5.381-5.484-5.381H7.484C4.036 3.667 2 5.65 2 9.005v7.323c0 3.354 2.036 5.339 5.484 5.339h9.032c3.448 0 5.484-1.985 5.484-5.339v-.312h-4.231c-1.964 0-3.556-1.552-3.556-3.466s1.592-3.467 3.556-3.467z",
    opacity: 0.4
  })));
};
export default SvgFinances;